<template>
  <header
    v-bind:class="[{ fa: $i18n.locale == 'fa' }, { en: $i18n.locale == 'en' }]"
  >
    <div v-if="!isMobile">
      <div class="container-fluid">
        <div class="row mobile-header-middle">
          <div class="col-lg-3 col-md-6">
            <div id="logo_home">
              <img
                src="/img/logo-pardis.png"
                @click="goToHome()"
                width="85%"
                alt="City tours"
                data-retina="true"
                style="cursor: pointer; margin-top: 8px"
              />
            </div>
          </div>

          <nav class="show-menu col-lg-7 col-md-1">
            <a
              class="cmn-toggle-switch cmn-toggle-switch__htx open_close"
              href="javascript:void(0);"
            >
              <span>Menu mobile</span>
            </a>
            <div class="main-menu">
              <div id="header_menu">
                <img
                  src="/img/logo-pardis.png"
                  width="400"
                  alt="City tours"
                  data-retina="true"
                />
              </div>
              <a href="#" class="open_close" id="close_in"
                ><i class="icon_set_1_icon-77"></i
              ></a>

              <div class="col-md-12 loading" v-if="isLoading">
                <loadingBar type="ripple" />
              </div>

              <ul v-else style="font-size: 17px !important">
                <li v-for="menu in menuList" v-if="IsUserAuthenticated">
                  <router-link :to="menu.path" class="custom-menu show-submenu">
                    {{ menu.title }}
                  </router-link>
                </li>
                <li>
                  <a
                    v-if="!IsUserAuthenticated"
                    href="http://ts.dariushgroup.com"
                    target="_blank"
                    class="custom-menu show-submenu"
                  >
                    {{ $t("HomeHeader.Fasttrack") }}
                  </a>
                </li>
                <li>
                  <a
                    v-if="!IsUserAuthenticated"
                    href="https://dp.dariushgroup.com"
                    target="_blank"
                    class="custom-menu show-submenu"
                  >
                    {{ $t("HomeHeader.DolphinPark") }}
                  </a>
                </li>
                <li>
                  <a
                    href="https://dariushgroup.com/HELP/%D8%B1%D8%A7%D9%87%D9%86%D9%85%D8%A7%DB%8C%20%D9%87%D8%AA%D9%84%20%D9%BE%D8%B1%D9%88%D8%A7%D8%B2.pdf"
                    target="_blank"
                    class="custom-menu show-submenu"
                  >
                    {{ $t("HomeHeader.guideness") }}
                  </a>
                </li>
                <!-- <a href="/profile/dashboard" class="custom-menu show-submenu">
                  پروفایل
                </a> -->
              </ul>

              <div
                v-if="GetSourceId === null && IsUserAuthenticated"
                class="alert alert-danger alert-white rounded"
                :class="{ active: showAlert }"
              >
                <div @click="showAlert = !showAlert" class="icon">
                  <i class="fa fa-times-circle"></i>
                </div>
                <strong>هشدار!</strong>
                <span>
                  حساب کاربری شما کامل نشده است، جهت تکمیل به
                  <span
                    style="color:#08446a; cursor:pointer;text-decoration:underline;font-size:15px,  margin: 0px 3px; "
                    @click="toToProfile"
                  >
                    پروفایل
                  </span>
                  مراجعه نمائید.
                </span>
              </div>
            </div>
          </nav>
          <div class="col-lg-2 col-md-5 header-opt">
            <!-- <div class="locale-changer">
              <select v-model="$i18n.locale" @change="checkDirection">
                <option
                  v-for="(lang, i) in langs"
                  :key="`Lang${i}`"
                  :value="lang"
                  
                >
                  {{ lang }}
                </option>
              </select>
            </div> -->
            <language-switcher />
            <div class="profile-opt">
              <PdkTopline />
            </div>
          </div>
        </div>
        <div
          v-if="GetSourceId === null && IsUserAuthenticated"
          class="profile-alert row"
        >
          <div
            class="alert alert-danger alert-white rounded"
            :class="{ active: showAlert }"
          >
            <div @click="showAlert = !showAlert" class="icon">
              <i class="fa fa-times-circle"></i>
            </div>
            <strong>هشدار!</strong>
            <span>
              حساب کاربری شما کامل نشده است، جهت تکمیل به
              <span
                style="color:#08446a; cursor:pointer;text-decoration:underline;font-size:15px,    margin: 0px 3px; "
                @click="toToProfile"
              >
                پروفایل
              </span>
              مراجعه نمائید.
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <div class="mobile-header-logo">
          <div id="logo_home">
            <img
              src="/img/logo-pardis.png"
              @click="goToHome()"
              alt="City tours"
              data-retina="true"
              style="cursor: pointer; margin-top: 8px"
            />
            <a id="usersToggle">
              <i
                v-if="IsUserAuthenticated"
                class="mobile-nav-user icon-user-1"
              ></i>
            </a>
            <span class="mobile-nav-button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 55.3 42.7"
                fill="#4e7eb4"
                xml:space="preserve"
              >
                <g>
                  <path
                    class="st0"
                    d="M7.2,4.2h40.3c2.3,0,4.1,1.8,4.1,4.1v0c0,2.3-1.8,4.1-4.1,4.1H7.2c-2.3,0-4.1-1.8-4.1-4.1v0   C3.1,6,4.9,4.2,7.2,4.2z"
                  />
                  <path
                    class="st0"
                    d="M7.2,17.2h40.3c2.3,0,4.1,1.8,4.1,4.1v0c0,2.3-1.8,4.1-4.1,4.1H7.2c-2.3,0-4.1-1.8-4.1-4.1v0   C3.1,19.1,4.9,17.2,7.2,17.2z"
                  />
                  <path
                    class="st0"
                    d="M7.2,30.5h40.3c2.3,0,4.1,1.8,4.1,4.1v0c0,2.3-1.8,4.1-4.1,4.1H7.2c-2.3,0-4.1-1.8-4.1-4.1v0   C3.1,32.3,4.9,30.5,7.2,30.5z"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>
        <div class="main-menu">
          <div id="header_menu">
            <img src="/img/logo-pardis.png" width="100%" alt="City tours" />
          </div>
          <a href="#" class="open_close" id="close_in"
            ><i class="icon_set_1_icon-77"></i
          ></a>

          <div class="col-md-12 loading" v-if="isLoading">
            <loadingBar type="ripple" />
          </div>

          <ul v-else style="font-size: 17px !important">
            <PdkTopline />
            <li v-for="menu in menuList">
              <router-link :to="menu.path" class="custom-menu show-submenu">
                {{ menu.title }}
              </router-link>
            </li>
            <!-- <a
            v-if="!IsUserAuthenticated"
              href="https://dp.dariushgroup.com/"
              target="_blank"
              class="custom-menu show-submenu"
            >
              دلفین
            </a> -->

            <a
            v-if="!IsUserAuthenticated"
              href="http://ts.dariushgroup.ir"
              target="_blank"
              class="custom-menu show-submenu"
            >
              {{ $t("HomeHeader.Fasttrack") }}
            </a>
            <a
              href="https://dariushgroup.com/HELP/%D8%B1%D8%A7%D9%87%D9%86%D9%85%D8%A7%DB%8C%20%D9%87%D8%AA%D9%84%20%D9%BE%D8%B1%D9%88%D8%A7%D8%B2.pdf"
              target="_blank"
              class="custom-menu show-submenu"
            >
              راهنما
            </a>
            <!-- <a  v-if="!IsUserAuthenticated" href="/profile/dashboard" class="custom-menu show-submenu">
              پروفایل
            </a> -->
          </ul>
        </div>
        <!-- <div class="users-menu">
          <PdkTopLineMob />
        </div> -->

        <!-- End main-menu -->
      </div>
    </div>
  </header>
</template>


<script>
import $ from "jquery";
import PdkTopline from "../components/PdkTopline";
import PdkTopLineMob from "../components/PdkTopLineMob";
import store from "../views/profile/store/index";
import loadingBar from "../components/PdkLoading.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import { locale } from "moment";

export default {
  name: "PdkHeader",
  store,
  data() {
    return {
      tabIndex: 0,
      menuList: [],
      isLoading: false,
      isMobile: true,
      locale: "",
      showAlert: false,
      langs: ["fa", "en"],
      localee: "fa",
    };
  },
  components: { PdkTopline, loadingBar, PdkTopLineMob, LanguageSwitcher },
  computed: {
    IsUserAuthenticated() {
      return this.$store.getters.IsUserAuthenticated;
    },
    GetSourceId() {
      return localStorage.getItem("SourceIdInReport");
    },
  },
  mounted: function () {
    /* Sticky nav */
    $(window).scroll(function () {
      "use strict";
      if ($(this).scrollTop() > 1) {
        $("header").addClass("sticky");
      } else {
        $("header").removeClass("sticky");
      }
    });

    /* Menu */
    $("#usersToggle").on("click", function () {
      $(".users-menu").toggleClass("shown");
    });
    $(".mobile-nav-button").on("click", function () {
      $(".main-menu").toggleClass("show");
    });

    $("a.show-submenu").on("click", function () {
      $(this).next().toggleClass("show_normal");
    });
    // $("#close_in").on("click", function () {
    //   $(".main-menu").toggleClass("show");
    // });
    $("a.show-submenu-mega").on("click", function () {
      $(this).next().toggleClass("show_mega");
    });

    $("a.open_close").on("click", function () {
      $(".main-menu").toggleClass("show");
    });
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created() {
    if (localStorage.getItem("UserId") !== null) {
      this.getAccessibility();
    }
  },

  methods: {
    goToHome() {
      if (this.$route.name != "main home")
        this.$router.push({
          path: "",
          name: "main home",
        });
    },

    checkDirection(e) {
      if (e.target.options.selectedIndex == 1) {
        document.body.classList.add("ltr");
        document.body.classList.remove("rtl");
      } else if (e.target.options.selectedIndex == 0) {
        document.body.classList.remove("ltr");
        document.body.classList.add("rtl");
      }
    },
    toToProfile() {
      this.$router.push({
        path: "/profile/dashboard",
      });
    },
    getAccessibility() {
      this.menuList = JSON.parse(localStorage.getItem("menuList"));
      if (this.menuList.length != 0) {
        this.menuList = this.menuList.filter(
          (p) => p.name === "topline"
        )[0].children;
        this.menuList.sort(function (a, b) {
          return a.sortId - b.sortId;
        });
      }

      this.localee = this.$i18n.locale;
      var locale = this.localee;
      this.menuList.map((x) => {
        x.title = this.$i18n.messages[locale].Menu["menu" + x.id];
      });

      return this.menuList;
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
};
</script>
<style lang="css" scoped>
.close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.5;
}

button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert h4 {
  margin-top: 0;
  color: inherit;
}

.alert .alert-link {
  font-weight: bold;
}

.alert > p,
.alert > ul {
  margin-bottom: 0;
}

.alert > p + p {
  margin-top: 5px;
}

.alert-dismissable {
  padding-right: 35px;
}

.alert-dismissable .close {
  position: relative;
  top: -2px;
  right: -21px;
  color: inherit;
}

.alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
}

.alert-danger hr {
  border-top-color: #e4b9c0;
}

.alert-danger .alert-link {
  color: #843534;
}

.alert {
  border-radius: 0;
  -webkit-border-radius: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11);
}

.alert-danger {
  background-color: #f2dede;
  border-color: #e0b1b8;
  color: #b94a48;
}

.alert-white {
  background-image: linear-gradient(to bottom, #ffffff, #f5f7f9);
  border-top-color: #d8d8d8;
  border-bottom-color: #bdbdbd;
  border-left-color: #cacaca;
  border-right-color: #cacaca;
  color: #404040;
  padding-left: 61px;
  position: fixed;
  top: 100px;
  -webkit-transition: all 470ms ease-out;
  -moz-transition: all 470ms ease-out;
  -ms-transition: all 470ms ease-out;
  -o-transition: all 470ms ease-out;
  transition: all 470ms ease-out;
}
.alert-white.active {
  visibility: hidden !important;
  opacity: 0;
}
.alert-white .icon {
  text-align: center;
  width: 45px;
  height: 100%;
  position: absolute;
  top: -1px;
  left: -1px;
  cursor: pointer;
  border: 1px solid #bdbdbd;
}

.alert-white .icon:after {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  display: block;
  content: "";
  width: 10px;
  height: 10px;
  border: 1px solid #bdbdbd;
  position: absolute;
  border-left: 0;
  border-bottom: 0;
  top: 50%;
  right: -6px;
  margin-top: -5px;
  background: #fff;
}

.alert-white.rounded {
  border-radius: 3px;
  -webkit-border-radius: 3px;
}

.alert-white.rounded .icon {
  border-radius: 3px 0 0 3px;
  -webkit-border-radius: 3px 0 0 3px;
}

.alert-white .icon i {
  font-size: 20px;
  color: #fff;
  left: 12px;
  margin-top: -10px;
  position: absolute;
  top: 50%;
}

.alert-white.alert-danger .icon,
.alert-white.alert-danger .icon:after {
  border-color: #ca452e;
  background: #da4932;
}

.show-mobile-menu {
  display: none;
}

.show-menu {
  display: block;
}

.profile-alert {
  display: none;
  margin: 20px 0px 0px 0px;
}

@media only screen and (min-width: 576px) and (max-width: 992px) {
  .show-menu {
    order: 3;
  }
  #logo_home i.mobile-nav-user {
    font-size: 30px !important;
  }
}
@media only screen and (max-width: 750px) {
  .show-mobile-menu {
    display: inline-block !important;
  }
  #logo_home {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #logo_home img {
    width: 80%;
  }
  #logo_home #usersToggle {
    margin-top: 8px;
  }
  #logo_home i.mobile-nav-user {
    font-size: 21px;
    color: #4e7eb4;

    margin-left: 6px;
  }
  .show-menu {
    display: none !important;
  }

  .profile-alert {
    display: block !important;
  }
}

.main {
  margin-right: 10px;
  position: relative;
  text-align: right;
}

label {
  width: 100%;
  position: absolute;
  line-height: 45px;
  top: 0px;
  left: 0px;
  background-color: #fff;
  padding-left: 20px;
  font-weight: 700;
  -webkit-transition: 0.04s ease-in-out;
  transition: 0.04s ease-in-out;
}

.list {
  box-shadow: -5px 5px 5px -5px #333;
  width: 100%;
  position: absolute;
  z-index: 1;
  top: 45px;
  left: 0px;
  border-top: 1px solid #eee;
  visibility: hidden;
  opacity: 0;
  cursor: pointer;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}

.item {
  min-width: 250px;
  width: 100%;
  line-height: 45px;
  padding-right: 20px;
  background-color: #fff;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
  font-weight: 400;
}

.item:hover {
  background-color: #eee;
}

/**********
***********/

#drop-1:checked ~ .list-1 {
  visibility: visible;
  opacity: 2;
  z-index: 10;
}

a:hover {
  color: #d5ab3d;
}

a {
  font-size: 15px;
}

.custom-menu {
  padding-right: 0px;
  padding-left: 20px;
}

.router-link-exact-active {
  color: #bf8604 !important;
  border-radius: 25px !important;
  padding-top: 10px !important;
}
</style>